import React, { useState, useEffect } from "react";
import axios from "axios";
import { Select, Badge, Input, DatePicker, Modal, Card, Row, Col, message, Image, Checkbox, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
const { RangePicker } = DatePicker;
const { Meta } = Card;
const AdminCourseMaterial = () => {
    // const navigate = useNavigate();
    // useEffect(() => {
    //     let source = window.location.pathname.split('/')[3];
    //     console.log(source);
    //     if (source == 'CoureseMaterial') {

    //     } else if (source == 'HomeWork'){

    //     }else
    // }, [window.location.pathname])
    return (
        <>
            <Row gutter={[8, 8]} >
                <Col span={24}>
                    <Row gutter={[16, 8]} align={'middle'}>
                        <Col>學期編號：1234</Col>
                        <Col>
                            <Select
                                style={{
                                    width: 200,
                                }}
                                // onChange={handleChange}
                                options={[
                                    {
                                        value: 'jack',
                                        label: 'Jack',
                                    },
                                    {
                                        value: 'lucy',
                                        label: 'Lucy',
                                    },
                                    {
                                        value: 'Yiminghe',
                                        label: 'yiminghe',
                                    },
                                ]}
                            /></Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row gutter={[8, 8]} align={'middle'}>
                        <Col>
                            <Button>上傳檔案</Button>
                        </Col>
                        <Col>
                            <Button>手機上傳</Button>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col md={6} sm={24}>
                            <Badge.Ribbon text="PowerPoint" color="green">
                                <Card style={{ paddingTop: '5px' }}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <p>第一週作業</p>
                                        </Col>
                                        <Col span={24}>
                                            瀏覽檔案
                                        </Col>
                                        <Col span={24}>
                                            <Row justify={'space-around'} gutter={[8, 8]}>
                                                <Col>
                                                    <Button className="example" style={{ backgroundColor: '#8BA8E0', color: '#ffffff' }}>點擊下載</Button>
                                                </Col>
                                                <Col>
                                                    <Button className="example" style={{ backgroundColor: '#E092A2', color: '#ffffff' }}>刪除</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Badge.Ribbon>
                        </Col>
                    </Row>
                </Col>
                {window.location.pathname.split('/')[3] != 'CourseMaterial' ? <>
                    <Col span={24} style={{ fontSize: '1.2rem', fontWeight: 500, letterSpacing: '3px' }}>本週學生{window.location.pathname.split('/')[3] == 'HomeWork' ? '回家作業' : '隨堂測驗'}情形 </Col>
                    <Col span={24}>
                        <Row>
                            <Col md={6} sm={24}>
                                <Card style={{ paddingTop: '5px' }}>
                                    <Row gutter={[8, 16]}>
                                        <Col span={24}>
                                            <p>第一週作業</p>
                                        </Col>
                                        <Col span={24}>
                                            瀏覽檔案
                                        </Col>
                                        <Col span={24}>
                                            <Row justify={'space-around'} gutter={[8, 8]}>
                                                <Col>
                                                    <Button className="example" style={{ backgroundColor: '#8BA8E0', color: '#ffffff' }}>點擊下載</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Col>

                </> : null}
            </Row>
        </>
    )
}
export default AdminCourseMaterial;